export default __webpack_public_path__ + "static/media/m_2.60fa45be.jpg";